import z from "zod";

const subscriptionPlanSchema = z
  .object({
    can_select: z.boolean(),
    cta_text: z.string(),
    currency: z.string(),
    description: z.string().nullable(),
    display_price: z.string().nullable(),
    features: z.array(z.object({ text: z.string() })),
    id: z.string(),
    interval: z.string().nullable(),
    is_free: z.boolean(),
    is_selected: z.boolean(),
    name: z.string(),
    price: z.string(),
    tax_display: z.string().nullable(),
  })
  .transform((subscription) => ({
    ...subscription,
    is_premium: subscription.id === "premium_monthly",
  }));

type SubscriptionPlan = z.infer<typeof subscriptionPlanSchema>;

export { subscriptionPlanSchema, type SubscriptionPlan };
